
/*----------------------
    BLOCKS INFO
---------------------- */
BlocksInfo = {
    init: function () {
        $(".bock-text__title").on("click", function () {
            if ($(window).width() > 641) {
                $("html, body").animate({ scrollTop: 0 }, 0);
            }
            $('.bock-text--info').scrollTop(0);

            $('.bock-text__title').not(this).removeClass('current');
            $(this).toggleClass("current");

            var block = $(this).data("block");
            $('.bock-text--info').not("#" + block).removeClass('open-block');
            $("#" + block).toggleClass("open-block");

            $(".bock-text__title-" + block).toggleClass("current");

            if ($(".bock-text--info").hasClass("open-block")) {
                $("body").addClass('open-block');

            } else {
                $("body").removeClass('open-block');
            }
        });

        $(".bock-text--info__mobile-close").on("click", function () {
            var panel = $(this).closest('.bock-text--info');
            panel.removeClass('open-block');
            $('.bock-text__title').removeClass('current');
            $("body").removeClass('open-block');
        });

        $("body").on("click", function (e) {
            if (!$(e.target).closest('.bock-text__title, .bock-text--info, .finish-help-link').length) {
                $('.bock-text--info').removeClass('open-block');
                $('.bock-text__title').removeClass('current');
                if ($(".bock-text--info").hasClass("open-block")) {
                    $("body").addClass('open-block');
                } else {
                    $("body").removeClass('open-block');
                }
            }
        })

    }
};

/*----------------------
    FINISH HELP LINK
---------------------- */
FinishHelp = {
    init: function () {
        /* Subtle link → opens finish-help overlay */
        $(document).on("click", ".finish-help-link", function (e) {
            e.preventDefault();
            if ($(window).width() > 641) {
                $("html, body").animate({ scrollTop: 0 }, 0);
            }
            $('.bock-text--info').scrollTop(0);
            $('.bock-text__title').removeClass('current');
            $('.bock-text--info').not('#finish-help').removeClass('open-block');
            $('#finish-help').toggleClass('open-block');

            if ($('#finish-help').hasClass('open-block')) {
                $('body').addClass('open-block');
            } else {
                $('body').removeClass('open-block');
            }
        });

        /* Option 1 → open samples drawer */
        $(document).on("click", ".finish-help__option[data-action='open-drawer']", function () {
            $("#samples-drawer").addClass("open");
            $("body").css("overflow", "hidden");
        });

        /* Close drawer */
        $(document).on("click", ".samples-drawer__close, .samples-drawer__backdrop", function () {
            $("#samples-drawer").removeClass("open");
            $("body").css("overflow", "");
        });

        /* Drawer CTA — select "I'll receive samples" variant, close panels, scroll to selectors */
        $(document).on("click", "#samples-drawer-atc", function () {
            /* Select the samples radio if not already checked */
            var $samplesRadio = $("input[data-samples-variant='true']");
            if ($samplesRadio.length && !$samplesRadio.prop("checked")) {
                $samplesRadio.prop("checked", true).trigger("change");
            }
            /* Close drawer */
            $("#samples-drawer").removeClass("open");
            $("body").css("overflow", "");
            /* Close finish-help panel if open */
            $("#finish-help").removeClass("open-block");
            $(".bock-text__title").removeClass("current");
            $("body").removeClass("open-block");
            /* Scroll to variant selectors so user sees the selection */
            setTimeout(function () {
                var $variantSection = $("[name='variant_section']").first();
                if ($variantSection.length) {
                    $("html, body").animate({ scrollTop: $variantSection.offset().top - 100 }, 400);
                }
            }, 300);
        });

        /* ESC key closes drawer */
        $(document).on("keydown", function (e) {
            if (e.key === "Escape" && $("#samples-drawer").hasClass("open")) {
                $("#samples-drawer").removeClass("open");
                $("body").css("overflow", "");
            }
        });
    }
};

/*----------------------
 STICKY
 ----------------------*/
Sticky = {
    init: function () {
        function sticky() {
            var height_menu = $(".header-menu__content").outerHeight();
            var height_div = $(".product__info").outerHeight() + height_menu;
            var height_window = $(window).height();

            if (height_div > height_window) {
                var result = height_div - height_window - height_menu;
                $(".product__info").css("top", -result);
            } else {
                $(".product__info").css("top", height_menu);
            }
        }
        sticky();

        $(window).on("resize", function () {
            sticky();
        });

        $("body").on("click", function (e) {
            setTimeout(function () {
                sticky();
            }, 1);
        })
    }
};


/*----------------------
    OPEN VARIATIONS
---------------------- */
openVariations = {
    init: function () {
        $(".attributes__title").on("click", function () {
            /* mr_test */
            if($(this).closest(".attributes-values").hasClass("open-desktop") && window.innerWidth >= 640){
              $(this).closest(".attributes-values").toggleClass("open-desktop");
            }else{
              $(this).closest(".attributes-values").removeClass("open-desktop");
              $(this).closest(".attributes-values").toggleClass("open");
            }
            /* mr_test*/
            /* before
              $(this).closest(".attributes-values").toggleClass("open");
            */
        });
        $("body").on("click", function (e) {
            if (!$(e.target).closest('.attributes__title, .attributes-values').length && window.innerWidth >= 640 ) {
              $(".attributes-values").removeClass("open");
              /* mr_test */
              $(".attributes-values").removeClass("open-desktop");  
              /* mr_test */
            }
        });
    }
};

/*----------------------
   SWIPER PRODUCT
---------------------- */
SwiperProduct = {
    init: function () {
        var productSwiper = document.querySelector(".swiper-product-images");
        if (!productSwiper) return;

        var swiper = productSwiper.swiper;

        if (!swiper && $(window).width() <= 640) {
            swiper = new Swiper(productSwiper, {
                hashNavigation: {
                    watchState: true,
                },
                navigation: {
                    nextEl: productSwiper.querySelector(".swiper-product-images-next"),
                    prevEl: productSwiper.querySelector(".swiper-product-images-prev"),
                },
            });

        }
        else if (!swiper) {
            swiper = new Swiper(productSwiper, {
                direction: "vertical",
                slidesPerView: "auto",
                hashNavigation: {
                    watchState: true,
                },
                mousewheel: {
                    invert: false,
                    forceToAxis: true
                },
                freeMode: {
                    enabled: true,
                    sticky: false,
                    momentumBounce: false
                },
                scrollbar: {
                    el: productSwiper.querySelector(".swiper-scrollbar"),
                    draggable: true,

                }
            });
        }

        if (window.MarlotProductGalleryVideo) {
            window.MarlotProductGalleryVideo.init(productSwiper, swiper);
        }
    }
};

/*----------------------
    SAMPLES VARIANT
---------------------- */
SamplesVariant = {
    init: function () {
        var $materialSelector = $(".samples-material-selector");
        var $legSection = $("[name='legs_variant_section']");
        var $steelOpt3 = $("[data-steel-option3='true']");
        var $summaryMsg = $(".samples-summary-msg");
        var summaryTpl = $summaryMsg.data("tpl") || "";

        /* ── Material card dynamic data (leg-family products) ── */
        var materialData = null;
        var $dataEl = $("#samples-material-data");
        if ($dataEl.length) {
            try { materialData = JSON.parse($dataEl.text()); } catch (e) {}
        }

        function getSelectedSize() {
            return $("[name='variant_section']").first()
                .find("input.variant_option:checked").val();
        }

        function getMaterialsSummary() {
            /* Leg-family products: use materialData */
            if (materialData && materialData.names) {
                var $active = $(".samples-material-card--active");
                var selectedLeg = $active.length ? $active.data("material") : materialData.currentMaterial;
                var surface = materialData.surfaceMaterial;
                var legName = materialData.names[selectedLeg] || "";
                if (legName && legName !== surface) {
                    var andWord = materialData.and || "y";
                    return surface + " " + andWord + " " + legName;
                }
                return surface || legName;
            }
            /* Non-leg-family: use fallback from data attribute */
            var fallback = $summaryMsg.data("fallback");
            if (fallback) return fallback;
            return "";
        }

        function updateMaterialCards() {
            if (!materialData) return;
            var size = getSelectedSize();
            $(".samples-material-card").each(function () {
                var mat = $(this).data("material");
                var info = materialData[mat];
                if (!info) return;
                var sizeData = info.sizes[size];
                var productUrl = info.url;
                if (!productUrl && info.handle) {
                    var localeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
                    productUrl = localeRoot.replace(/\/$/, "") + "/products/" + info.handle;
                }
                if (sizeData) {
                    $(this).attr("href", productUrl + "?variant=" + sizeData.id);
                } else {
                    var firstKey = Object.keys(info.sizes)[0];
                    if (firstKey) {
                        $(this).attr("href", productUrl + "?variant=" + info.sizes[firstKey].id);
                    }
                }
                if (materialData.currentMaterial === mat) {
                    $(this).removeAttr("href");
                }
            });
        }

        function updateSamplesLabels() {
            var materials = getMaterialsSummary();
            if (summaryTpl && materials) {
                $summaryMsg.text(summaryTpl.replace("__MAT__", materials));
            }
        }

        function checkSamplesState() {
            var $checked = $("input[data-samples-variant='true']:checked");
            if ($checked.length) {
                /* Show material selector (Micro/Wood cards) — only for leg-family */
                if ($materialSelector.length) {
                    $materialSelector.slideDown(200);
                    updateMaterialCards();
                }
                /* Summary message — always show */
                updateSamplesLabels();
                $summaryMsg.slideDown(200);
                /* Always hide leg family selector when samples selected */
                $legSection.slideUp(200);
            } else {
                $materialSelector.slideUp(200);
                $summaryMsg.slideUp(200);
                $legSection.slideDown(200);
            }
            /* Keep the legacy synthetic "samples-option3-summary" hidden — option3 now has
               its own native "I'll receive samples" value rendered alongside real values. */
            if ($steelOpt3.length) {
                $steelOpt3.find(".samples-option3-summary").hide();
                $steelOpt3.find(".samples-option3-summary input").prop("disabled", true).prop("checked", false);
            }
        }

        /* Material card click */
        $(document).on("click", ".samples-material-card", function () {
            updateSamplesLabels();
        });

        /* Listen for any variant radio changes */
        $(document).on("change", "input.variant_option", function () {
            checkSamplesState();
        });

        /* Initial check */
        checkSamplesState();
    }
};

$(document).ready(function () {
    BlocksInfo.init();
    openVariations.init();
    //Sticky.init();
    SwiperProduct.init();
    FinishHelp.init();
    SamplesVariant.init();

    /* ── Restore scroll position after variant/leg navigation ── */
    var savedScroll = sessionStorage.getItem("marlot_scroll_y");
    if (savedScroll) {
        sessionStorage.removeItem("marlot_scroll_y");
        setTimeout(function () {
            window.scrollTo(0, parseInt(savedScroll, 10));
        }, 150);
    }

    /* Save scroll position before leg-type or material-card navigation */
    $(document).on("click", "[data-leg-type], .samples-material-card[href]", function () {
        sessionStorage.setItem("marlot_scroll_y", window.scrollY);
    });
});
$(document).on('shopify:section:load', function (event) {
    BlocksInfo.init();
    openVariations.init();
    //Sticky.init();
    SwiperProduct.init();
    FinishHelp.init();
    SamplesVariant.init();
});
